import { PushTemoignages } from '@components/push-temoignages/models';
import { Block } from '@shared/models';

export const pushTemoignagesMock: Block<PushTemoignages> = {
  type: 'push-temoignages',
  data: {
    title: 'À leur tour de [[vous inspirer]]',
    cta: {
      label: 'Voir tous les témoignages clients',
      url: '/mock-temoignages-clients',
    },
  },
};
